export const Languages = [
    {
        ID: 'ro',
        LABEL: 'Română'
    }, {
        ID: 'en',
        LABEL: 'Engleză'
    }
];
